module.exports = __webpack_public_path__ + "media/images/icon__facebook@2x-daffeabe80407d62f3ba2bc007fedf67.png";